<template>
  <section class="section top-section">
    <b-container>
      <b-row>
        <b-col offset-lg="1" lg="5" order-lg="2" class="explainer-text">
          <p class="sub-title">
            Capsules give you a framework to start your fashion journey:
          </p>

          <ul class="explainer-list">
            <li :class="[step0Done ? 'done' : 'done']">
              Search capsules that contain items you own
            </li>
            <li
              :class="[
                step0Done ? 'done' : 'undone',
                showStep0 ? 'highlight' : ''
              ]"
            >
              Swipe to curate new outfit
            </li>
            <li
              :class="[
                step1Done ? 'done' : 'undone',
                showStep1 ? 'highlight' : ''
              ]"
            >
              Stitch your favourite combination
            </li>
            <li
              :class="[
                step2Done ? 'done' : 'undone',
                showStep2 ? 'highlight' : ''
              ]"
            >
              Discover top rated outfits for each capsule
            </li>
          </ul>
          <form-horizontal
            class="mt-4"
            text="Let me in!"
            v-if="!showStep0 && !showStep1 && !showStep2"
          />
        </b-col>

        <b-col lg="6" order-lg="1">
          <b-row>
            <b-col class="capsule-col">
              <div
                class="steps-wrapper steps-wrapper-step-0"
                v-bind:class="{ invisible: !showStep0 }"
                data-aos="fade-down"
                data-aos-mirror="true"
                data-aos-once="false"
              >
                <div class="media media-step-0">
                  <div class="media-body">
                    <h3 class="step-0-text wiggle is-active">Swipe!</h3>
                  </div>
                </div>
                <div class="clearfix">
                  <b-img
                    class="step-0 "
                    width="150"
                    src="@/assets/img/anatomy/arrow-accent.png"
                  ></b-img>
                </div>
              </div>
              <div
                class="steps-wrapper steps-wrapper-step-1"
                v-bind:class="{ invisible: !showStep1 }"
              >
                <div class="clearfix">
                  <b-img
                    class="step-1"
                    width="150"
                    src="@/assets/img/anatomy/arrow-accent.png"
                  ></b-img>
                </div>
              </div>
              <div
                class="steps-wrapper steps-wrapper-step-2"
                v-bind:class="{ invisible: !showStep2 }"
              >
                <div class="media media-step-2">
                  <div class="media-body">
                    <h3 class="step-2-text wiggle is-active">Click!</h3>
                  </div>
                </div>
                <div class="clearfix">
                  <b-img
                    class="step-2"
                    width="150"
                    src="@/assets/img/anatomy/arrow-accent.png"
                  ></b-img>
                </div>
              </div>
              <div ref="tempCapsuleContainer">
                <Capsule />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div class="outfits-content" ref="tempOutfitsContainer">
                <CapsuleOutfit
                  v-for="(outfit, index) in temporaryOutfits"
                  :key="index"
                  :outfit="outfit"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Capsule from "@/components/landing/capsuleAnatomy/Capsule";
import CapsuleOutfit from "@/components/landing/capsuleAnatomy/CapsuleOutfit";
import FormHorizontal from "@/components/landing/FormHorizontal";
import { mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("slidingCarousel", () => {
      if (this.showStep0 == true) {
        this.transitionToStep1();
      }
    });

    bus.$on("stitchingOutfit", () => {
      this.transitionToStep2();
    });

    bus.$on("clickingStitchedOutfit", () => {
      if (this.showStep2 == true) {
        this.showStep2 = false;
      }
      const element = this.$refs["tempCapsuleContainer"];
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  },

  components: {
    Capsule,
    CapsuleOutfit,
    FormHorizontal
  },

  data() {
    return {
      showStep0: true,
      showStep1: false,
      showStep2: false
    };
  },

  computed: {
    ...mapGetters(["temporaryOutfits"]),

    step0Done() {
      return this.showStep0 === false;
    },

    step1Done() {
      return this.step0Done && this.showStep1 === false;
    },

    step2Done() {
      return this.step1Done && this.showStep2 === false;
    }
  },

  methods: {
    transitionToStep1() {
      this.showStep0 = false;

      if (this.showStep2 == false) {
        this.showStep1 = true;
      }
    },

    transitionToStep2() {
      if (this.showStep0 == false && this.showStep1 == true) {
        this.showStep0 = false;
        this.showStep1 = false;
        this.showStep2 = true;

        const element = this.$refs["tempOutfitsContainer"];
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";

.top-section {
  background-color: $primary-blue;
  color: #fff;
  padding-top: 100px;
  padding-bottom: 100px;

  @include for-tablet-landscape-up {
    padding-top: 200px;
    padding-bottom: 200px;
  }

  .outfits-content {
    background-color: #f9f9f9;
    border-top: 3px solid $primary-accent;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;

    display: grid;
    grid-template-columns: repeat(auto-fill, 150px);
    grid-gap: 0.8rem;
    justify-content: center;
    padding: 1rem;
    margin: 20px auto;

    @include for-tablet-portrait-up {
      grid-gap: 1.5rem;
    }
  }

  .explainer-text {
    margin-bottom: 100px;

    .explainer-list {
      line-height: 2.5;
      padding-left: 50px;

      li {
        position: relative;
        padding-left: 20px;
        margin-bottom: 10px;
      }

      li.undone {
        list-style-type: circle;
      }

      li.done {
        list-style-type: none;

        &:before {
          color: $primary-accent;
          position: absolute;
          top: 0;
          left: -20px;
          content: "✓";
        }
      }
    }

    .sub-title {
      font-size: 2rem;
      font-weight: 100;
      margin-bottom: 30px;
    }

    .highlight {
      font-weight: bold;
    }
  }

  .steps-wrapper {
    transition: all 0.3s ease-in-out;

    &.invisible {
      opacity: 0;
    }

    &.steps-wrapper-step-0 {
      position: absolute;
      top: -47px;
      left: -40px;
      z-index: 5;

      .step-0 {
        position: relative;
        transform: rotate(90deg);
      }
    }

    &.steps-wrapper-step-1 {
      position: absolute;
      top: -79px;
      right: 65px;
      z-index: 1;

      .step-1 {
        position: relative;
        transform: rotate(195deg) scaleX(-1);
      }
    }

    &.steps-wrapper-step-2 {
      position: absolute;
      bottom: -20px;
      left: 110px;
      z-index: 1;

      .step-2 {
        position: relative;
        transform: rotate(-210deg);
      }
    }
  }

  .media {
    .number {
      margin-right: 15px;
      margin-left: -4px;
      background: $primary-accent;
      color: #fff;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      text-align: center;
      font-size: 1.4em;
      border: 4px solid #fff;
      box-shadow: 2px 2px 2px rgba(50, 50, 50, 0.4);

      .inner {
        position: relative;
        top: 0.06em;
      }
    }

    &.media-step-2 {
      position: relative;
      left: 128px;
      top: 50px;

      .step-2-text {
        color: #ffffff;
        transform: rotate(-22deg);
        position: relative;
        // MAKE SURE YOU HAVE AN ACCESSIBE FOCUS STATE
        outline: none;
      }
    }

    &.media-step-0 {
      position: relative;
      left: 120px;
      top: -21px;

      .step-0-text {
        color: #ffffff;
        transform: rotate(0deg);
        position: relative;
        // MAKE SURE YOU HAVE AN ACCESSIBE FOCUS STATE
        outline: none;

        &.wiggle {
          width: fit-content;
          display: table;
        }

        &.wiggle.is-active {
          animation: 2s wiggle ease-in-out infinite;
        }

        @keyframes wiggle {
          0% {
            transform: rotate(-45deg);
          }
          20% {
            transform: rotate(-22deg);
          }
          40% {
            transform: rotate(-57deg);
          }
          60% {
            transform: rotate(-37deg);
          }
          90% {
            transform: rotate(-43deg);
          }
          100% {
            transform: rotate(-45deg);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/CapsuleSection.vue